import React, { ReactElement, useEffect } from "react";
import { GraphqlBundle } from "$gql/core";
import { QueryHookOptions } from "react-apollo";
import { useQueryBundle } from "source/hooks";
import LoadingBlock from "components/Loading/LoadingBlock";
import styles from "./PricingDataLoader.module.scss";

interface Props<Result, Vars> {
  query: GraphqlBundle<Result, Vars>;
  options?: QueryHookOptions<Result, Vars>;
  callBack(result: Result): void;
}

export default function PricingDataLoader<Result, Vars>({
  query,
  options,
  callBack,
}: Props<Result, Vars>): ReactElement {
  const queryResult = useQueryBundle(query, options);

  useEffect(() => {
    if (queryResult.state === "DONE") {
      callBack(queryResult.data);
    }
  }, [queryResult.state]);

  return (
    <div className={styles.loadingContainer}>
      <LoadingBlock />
    </div>
  );
}
